module.exports = __webpack_public_path__ + "static/media/image-slider02.c232caca.jpg";